module.exports = __webpack_public_path__ + "img/financials_blue_250px.59b35014.svg";